import type { QuestEligibleReward } from './types'

export type RewardIneligibilityReason = 'sold_out' | 'inactive' | 'insufficient_points'

export interface RewardEligibility {
  eligible: boolean
  reason: RewardIneligibilityReason | null
}

const isSoldOut = (reward: QuestEligibleReward) => reward.quantity === 0

export const computeRewardEligibility = (
  reward: QuestEligibleReward,
  runScore: number
): RewardEligibility => {
  if (isSoldOut(reward)) return { eligible: false, reason: 'sold_out' }
  if (!reward.active) return { eligible: false, reason: 'inactive' }
  if (runScore < reward.redeem_points_required) {
    return { eligible: false, reason: 'insufficient_points' }
  }

  return { eligible: true, reason: null }
}

export const sortEligibleRewards = (
  rewards: QuestEligibleReward[]
): QuestEligibleReward[] =>
  [...rewards].sort((a, b) => {
    if (isSoldOut(a) && !isSoldOut(b)) return 1
    if (!isSoldOut(a) && isSoldOut(b)) return -1
    return a.redeem_points_required - b.redeem_points_required
  })
